import React from 'react';
import AuthForm from '../pages/AuthForm';

const LoginPage: React.FC = () => {
  return <AuthForm mode="login" />;
};

export default LoginPage; 